import { Typography } from '@sunwebgroup/uds-ui/typography'
import { isEmpty } from 'ramda'
import { use } from 'react'
import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { busesSelector } from '@/scopes/prices/components/selectors'
import { BusCard } from '@/scopes/prices/components/TransportSelector/BusSelector/BusCard'
import { InboundTitle, OutboundTitle } from '@/scopes/prices/components/TransportSelector/BusSelector/Headers'
import { CollapseByHeight } from '@/scopes/prices/components/TransportSelector/CollapseByHeight'
import { Column } from '@/scopes/prices/components/TransportSelector/Column'
import { createBusComponentInteractionEvent } from '@/scopes/prices/domain/analytics'
import { PricesActionsContext } from '@/scopes/prices/domain/PricesActionsContext'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './BusSelectorDesktop.module.css'

export function BusSelectorDesktop() {
  const intl = useIntl()
  const { setOutboundBusId, setInboundBusId } = use(PricesActionsContext)
  const { outboundBuses, inboundBuses, selectedOutboundBusId, selectedInboundBusId } = usePricesSelector(busesSelector)
  const { sendEvent } = useAnalytics()

  if (isEmpty(outboundBuses) || isEmpty(inboundBuses))
    return null

  function handleCollapseToggle(result: string) {
    sendEvent(createBusComponentInteractionEvent({ type: 'outbound', result }))
  }

  const selectOutboundBus = (id: string) => {
    setOutboundBusId(id)
  }

  const selectInboundBus = (id: string) => {
    setInboundBusId(id)
  }

  const content = (
    <div className={styles.wrapper} id="BusSelector">
      <Column className={styles.column} value={selectedOutboundBusId as string}>
        <OutboundTitle />
        {outboundBuses.map(item => (
          <BusCard
            key={item.id}
            cityName={item.departureCityName}
            stationName={item.departureStationName}
            date={item.departureDate}
            {...item}
            isSelected={selectedOutboundBusId === item.id}
            setSelected={selectOutboundBus}
          />
        ))}
      </Column>
      <Column className={styles.column} value={selectedInboundBusId as string}>
        <InboundTitle />
        {inboundBuses.map(item => (
          <BusCard
            key={item.id}
            cityName={item.arrivalCityName}
            stationName={item.arrivalStationName}
            isSelected={selectedInboundBusId === item.id}
            {...item}
            setSelected={selectInboundBus}
          />
        ))}
      </Column>
    </div>
  )
  return (
    <div className={styles.busSelectorContainer}>
      <Typography className={styles.busSelectorTitle} variant="display-f-regular">
        {intl.formatMessage({ id: 'prices_transport_selector_bus-selector_title' })}
      </Typography>
      {outboundBuses.length < 3
        ? (
            <>{content}</>
          )
        : (
            <CollapseByHeight
              openText={intl.formatMessage({ id: 'prices_transport_selector_bus-selector-show-less' })}
              closeText={intl.formatMessage({ id: 'prices_transport_selector_bus-selector-show-more' })}
              height="370px"
              onClick={handleCollapseToggle}
            >
              {content}
            </CollapseByHeight>
          )}
    </div>
  )
}
